import { EventEmitter } from 'events';
import { merge } from 'lodash';
import Dispatcher from 'core/Dispatcher';
import Actions from 'constants/Actions';

const CHANGE_EVENT = 'change';

var _tmp = {
    name: 'booking',
};

function updateTmp(name, value) {
    merge(_tmp, {[name]: value});
}

class TmpStore extends EventEmitter {

    /**
     * @param {function} callback
     */
    addChangeListener(callback) {
        this.on(CHANGE_EVENT, callback);
    }

    /**
     * @param {function} callback
     */
    removeChangeListener(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    }

    emitChange() {
        this.emit(CHANGE_EVENT);
    }

    normalizeState(result) {
        result.tmp = _tmp;
        return result;
    }

    denormalizeState(normalizedResult) {
        if (normalizedResult.tmp) {
            for (let key in normalizedResult.tmp) {
                let value = normalizedResult.tmp[key];
                updateTmp(key, value);
            }
        }
    }

    dispatchToken = Dispatcher.register((action) => {

        const { payload } = action;

        switch (action.type) {

            case Actions.UPDATE_TMP:
                for (let name in payload) {
                    let value = payload[name];
                    updateTmp(name, value);
                }
                break;
            
            default:
                return;
        }

        this.emitChange();
    })

}

export default new TmpStore();


// WEBPACK FOOTER //
// ./client/stores/TmpStore.js